import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { OfferType } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { SelectionButtonSixthVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe } from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  selector: 'b2c-variant6',
  styleUrl: './variant6.component.scss',
  templateUrl: './variant6.component.html',
  imports: [SafePipe, RewardPipe, ButtonComponent],
})
export class Variant6Component extends SelectionButtonBaseClass {
  protected readonly OfferType: typeof OfferType = OfferType;
  config = input.required<SelectionButtonSixthVariantConfig>();
}
